import React, { Component } from "react";
import classNames from "classnames";
import Icon from "../Icon/Icon";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as authDrawerActions from "../../../actions/authDrawer";
import * as authDrawerConstants from "../../../constants/authDrawer";

import styles from "./AuthDrawer.css";

class ForgotPasswordFour extends Component {
  changeStep(step) {
    this.props.authDrawerActions.changeStep(step);
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.textCenter}>
          <Icon className={styles.checkmark} name="check/rounded" />
        </div>

        <div className={styles.marginTop20}>
          We have updated your password. You can now log in.
        </div>

        <div className={classNames(styles.nextButton, styles.marginTop20)}>
          <button
            onClick={this.changeStep.bind(this, authDrawerConstants.SIGNIN)}
            className={classNames(
              styles.blueButton1,
              styles.block,
              styles.centered
            )}
          >
            Sign In
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    authDrawer: state.authDrawer,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    authDrawerActions: bindActionCreators(authDrawerActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgotPasswordFour);
